// extracted by mini-css-extract-plugin
module.exports = {"quizCreator":"QuizCreator_quizCreator__1GHtY","error":"QuizCreator_error__1l3IX"};